<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group label="Add Ons" :label-cols="3">
          <multiselect
            :multiple="true"
            placeholder="Select Add Ons"
            v-model="selected"
            :options="options"
            label="name"
            trackBy="id"
          ></multiselect>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import TestPackageCollection from "../../collections/lab/TestPackageCollection";

export default {
  name: "AddOnSelect",
  components: { Multiselect },
  props: {
    addOns: {
      type: [Object, Array],
      default: () => new TestPackageCollection()
    },
    selectedAddOns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: [],
      selected: []
    };
  },
  watch: {
    selected: {
      handler(value) {
        let addOns = JSON.parse(JSON.stringify(value));
        if (addOns) {
          this.$emit("onAddOnSelect", addOns);
        }
      },
      deep: true
    }
  },
  created() {
    let options = [];
    if (this.addOns) {
      if (_.isArray(this.addOns) && this.addOns.length) {
        this.addOns.forEach(addOn => {
          options.push(JSON.parse(JSON.stringify(addOn)));
        })
      } else if (_.isObject(this.addOns) && this.addOns.models.length) {
        this.addOns.models.forEach(addOn => {
          options.push(JSON.parse(JSON.stringify(addOn)));
        });
      }
    }

    this.options = options;
    let selected = [];
    if (this.selectedAddOns && this.selectedAddOns.length) {
      this.selectedAddOns.forEach(addOn => {
        selected.push(addOn);
      });
    }
    this.selected = selected;
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
